module.exports = __webpack_public_path__ + "img/logo.2cb1178d.png";